import React, { useEffect, useState } from 'react';
import './MetroCitiesModal.css'; // Import your custom CSS file
import { getcities } from '../../utils/api';
import { useNavigate, useLocation } from 'react-router-dom';

const MetroCitiesModal = ({ showModal, onClose, onSelectCity }) => {

    const [cityData, setCityData] = useState([]);
    const navigate = useNavigate();
    const location = useLocation();
    const fetchCity = async () => {
        try {
            const response = await getcities();
            setCityData(response?.data);
        } catch (error) {
        }
    };

    useEffect(() => {
        fetchCity();
    }, []);


    if (!showModal) return null;

    const handleCityClick = (city) => {
        // const cityLower = city.toLowerCase();
        localStorage.setItem('selectedCity', city);  // Store city in localStorage
        const pathAfterCity = window.location.pathname.split('/').slice(2).join('/');
        if (pathAfterCity === '/') {
            const newUrl = `/${city.toLowerCase()}/${pathAfterCity}`;
            window.location.href = newUrl;
        } else if (pathAfterCity == '') {
            const newUrl = `/${city.toLowerCase()}${window.location.pathname}`;
            window.location.href = newUrl;
        } else {
            const newUrl = `/${city.toLowerCase()}${window.location.pathname}`;
            window.location.href = newUrl;
        }
        onClose();
    };

    return (
        <div className="modal-overlayM">
            <div className="modal-contentM">
                <button className="close-btn" onClick={onClose}>×</button>
                <h4 className='text-start'>Select your City</h4>
                <hr />
                <div className="city-list">
                    {cityData?.map((city, index) => (
                        <div
                            key={index}
                            className="city-item"
                            onClick={() => handleCityClick(city.city_name)}
                        >
                            <p>{city.city_name}</p>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
}

export default MetroCitiesModal;
